<template>
  <div class="user-info-wrapper spacex-8">
    <div v-if="user && user.files_urls" :style="{ width: `${avatarSize}px` }">
      <Avatar
        class="inner"
        :pic="user.files_urls.avatar_thumbnail"
        :name="user.name || user.email"
        :size="avatarSize"
      />
    </div>
    <div v-else :style="{ width: `${avatarSize}px` }">
      <Avatar class="inner" :name="user.name || user.email" :size="avatarSize" />
    </div>
    <div class="user-info" :class="{ 'user-info_horizontally': showInOneRow }">
      <div class="spacex-4 user-info-wrapper__name-position">
        <div class="user-name text text-black text-sm no-wrap">
          {{ user.name }}
        </div>
        <slot name="after-name">
          <div
            v-if="showPosition && !positionInBottom && !full"
            class="user-name text grey-500 text-sm"
          >
            {{ user.position }}
          </div>
        </slot>
      </div>
      <div v-if="full" class="user-position user-contacts">
        <div v-if="user.position">{{ user.position }}</div>
        <div v-if="user.role">{{ roles[user.role] }}</div>
      </div>
      <div class="user-contacts" :class="{ 'user-contacts_full': full }">
        <div
          v-if="user.email"
          class="user-email text grey-500 text-sm"
          :class="{ 'user-email_full': full }"
        >
          <span>{{ user.email }}</span>
        </div>
        <div v-if="user.phone_number" class="user-phone text grey-500 text-sm">
          {{ user.phone_number }}
        </div>
        <div
          v-if="showPosition && positionInBottom && user.position"
          class="user-phone text grey-500 text-sm"
        >
          {{ user.position }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Avatar from '@/components/avatars/Avatar';
  import { mapState } from 'vuex';

  export default {
    name: 'UserInfo',
    components: { Avatar },
    computed: {
      ...mapState('global', ['roles']),
    },
    props: {
      user: {
        type: Object,
        required: true,
      },
      showPosition: {
        type: Boolean,
        default: true,
      },
      showInOneRow: {
        type: Boolean,
        default: false,
      },
      avatarSize: {
        type: [Number, String],
        default: 32,
      },
      positionInBottom: Boolean,
      full: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
<style lang="scss">
  @import 'src/styles/components/user-info';
</style>
